import classNames from "classnames";
import { ReactNode } from "react";

import styles from "./floating-buttons.module.css";

type FloatingButtonsProps = {
  children: ReactNode;
  justify?: "right";
  fullWidth?: boolean;
};

export const FloatingButtons = ({
  children,
  justify,
  fullWidth = false
}: FloatingButtonsProps) => {
  const floatingButtonsClasses = classNames(styles.wrapper, {
    [styles["justify-right"]]: justify === "right",
    [styles["full-width"]]: fullWidth,
  });

  return <div className={floatingButtonsClasses}>{children}</div>;
};
